



































import { Component, Vue } from "vue-property-decorator";
import { copyContentTemplate } from "@/services/contentTemplates/contentTemplateService";

@Component
export default class ContentTemplateCopyModal extends Vue {
    name = "";
    copyName = "";
    id = "";

    open(id: string, name: string) {
        this.name = name;
        this.copyName = `${this.name} - copy`;
        this.id = id;
        this.$bvModal.show("modal-copy");
    }

    confirm() {
        this.$bvModal.hide("modal-copy");
        copyContentTemplate(this.id, this.copyName).then(() => {
            this.$emit("reload");
        });
    }

    decline() {
        this.$bvModal.hide("modal-copy");
    }
}
